import axios from 'axios';
import store from '../../store';
import customer from './customer';
import manager from './manager';

const model = () => {
	return {
		id: 			null,

		ref:			'',
		received:		'',
		deadline: 		'',
		urgent:			false,

		customer_id:	null,
		manager_id:		null,
		builder:		'',

		address:		'',
		zip:			'',
		city:			'',

		lat:			'',
		lng:			'',

		checked:		'no',		// yes, no
		handover:		'no',
		
		type:			null,
		color:			null,// yes, no, pre

		desc:			'',

		status:			'pending',
		completed:		null,

		_embedded: {
			photos:		{
				before:	[],
				after:	[]
			},
			lines:		[],
			customer:	customer.model(),
			manager:	manager.model()
		}
	};
};

const readOpen = async (params) => {
	//return (await axios.get('/todos/open')).data;
};

const save = async (model) => {
	/*try {
		if (model.id) {
			await axios.put(`/todos/${model.id}`, model);
		} else {
			await axios.post(`/todos`, model);
		}

		return true;
	} catch (err) {
		return false;
	}*/
};

const read = async(id) => {
	//return (await axios.get(`/todos/${id}`)).data;
};

const window = async (model, submit) => {
	store.dispatch('win/push', {
		component: 	'job-window-view',
		model:		model,
		async submit(model) {
			return await submit(model);
		}
	});
};

const open = async (id, onSave) => {
	window(id ? await read(id) : {}, async (model) => {
		if (await save(model)) {
			if (onSave) onSave();
			return true;
		}

		return false;
	});
};

const del = async (id) => {
	//await axios.delete(`/todos/${id}`);
};

const close = async (id) => {
	//await axios.put(`/todos/${id}/close`);
};

const checked = () => {
	return [
		{
			label: 'Ja',
			value: 'yes'
		},
		{
			label: 'Nej',
			value: 'no'
		}
	];
};

const handover = () => {
	return [
		{
			label: 'Ja',
			value: 'yes'
		},
		{
			label: 'Nej',
			value: 'no'
		},
		{
			label: 'Forafleveret',
			value: 'pre'
		}
	];
};

const types = () => {
	return [
		{
			label:	'Alu rep.',
			value:	'alu_rep',
			color:	'#00d873'
		},
		{
			label:	'Indv. ramme',
			value:	'int_frame',
			color:	'#0696de'
		},
		{
			label:	'Hoveddør',
			value:	'front_door',
			color:	'#a840b7'
		},
		{
			label:	'Bundstykke',
			value:	'bottom_piece',
			color:	'#f5c700'
		},
		{
			label:	'Glaspolering',
			value:	'glass_polish',
			color: 	'#f37500'
		}
	];
};

const colors = () => {
	return [
		{
			label:	'Granit',
			value:	'granite'
		},
		{
			label:	'Glat',
			value:	'smooth'
		}
	];
};

export default {
	model,
	readOpen,
	save,
	read,
	open,
	window,
	del,
	close,
	types,
	colors,
	checked,
	handover
};